export const GetStartedPage = {
  title: 'Get started',
  heading: 'Tell us about your company',
  description: "Share a few details, and we'll reply with a marketing plan and a price.",
};

export const ProjectRequestFormContent = {
  title: 'Marketing inquiry',
  description: 'Fields marked with an asterisk are required. Most requests take about three minutes.',
  sections: {
    requester: 'About you',
    company: 'About your company',
    needs: 'What you need',
    timing: 'Timing',
    details: 'Details',
  },
  serviceAreaPlaceholder: 'States or regions you serve',
  websitePlaceholder: 'yourcompany.com',
  deadlineHint: 'Working toward a trade show, a product launch, or a bid date? Pick that date.',
  goalsPlaceholder: 'The projects or clients you want more of, what has worked before, and anything else we should know.',
  submitLabel: 'Send inquiry',
  submittingLabel: 'Sending inquiry',
  privacyNote: 'Your details are used only to prepare your plan.',
  success: {
    title: 'Inquiry received',
    description: "Thanks for the details. We'll review your company and reply with a marketing plan and a price.",
    actionLabel: 'Send another inquiry',
    homeLinkLabel: 'Back to home',
  },
};

export const CompanyTypeOptions = [
  { value: 'glazing-contractor', label: 'Glazing contractor' },
  { value: 'cladding-installer', label: 'Cladding or panel installer' },
  { value: 'system-manufacturer', label: 'System manufacturer' },
  { value: 'material-manufacturer', label: 'Material manufacturer' },
  { value: 'other', label: 'Other' },
];

export const BudgetOptions = [
  { value: 'under-2500', label: 'Under $2,500 a month' },
  { value: '2500-5000', label: '$2,500 to $5,000 a month' },
  { value: '5000-10000', label: '$5,000 to $10,000 a month' },
  { value: 'over-10000', label: 'Over $10,000 a month' },
  { value: 'not-sure', label: 'Not sure yet' },
];

export const ReferralOptions = [
  { value: 'email', label: 'An email from our team' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'referral', label: 'A colleague or referral' },
  { value: 'search', label: 'A search engine' },
  { value: 'trade-show', label: 'A trade show' },
  { value: 'other', label: 'Other' },
];

export const NextSteps = {
  title: 'What happens next',
  steps: [
    { title: 'We review your company', description: 'We look at your website, your projects, and how you show up in search.' },
    { title: 'You get a plan and a price', description: 'Channels, deliverables, and a monthly price, all in writing.' },
    { title: 'Work starts when you approve', description: 'Nothing is started or billed until you say go.' },
  ],
};